import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TimeOffService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getExistingDates(userKeyID: number, showApprovedOnly: boolean, startDateString: string, endDateString: string) {
    let url = "/Time-Off/GetExistingDates?userKeyId=" + userKeyID + "&showApprovedOnly=" + showApprovedOnly;
    if (startDateString != null) {
      url += "&startDateString=" + startDateString;
    }
    if (endDateString != null) {
      url += "&endDateString=" + endDateString;
    }
    return this.http.get(url).toPromise();
  }

  getDefaultWorkHours(id: number) {
    return this.http.get("/Time-Off/GetDefaultWorkHours?id=" + id).toPromise();
  }

  getEmployees() {
    return this.http.get("/TimeOff/GetEmployees").toPromise();
  }

  getRequestHistory(userKeyID: number) {
    return this.http.get("/Time-Off/GetRequestHistory?id=" + userKeyID).toPromise();
  }

  getPayPeriods(pREHKeyID: number) {
    return this.http.get("/Time-Off/GetPayPeriods?id=" + pREHKeyID).toPromise();
  }

  cancelLeaveRequest(leaveRequestID: number, keyID: number) {
    return this.http.post("/Time-Off/CancelLeaveRequest",
      {
        leaveRequestID: leaveRequestID,
        KeyID: keyID
      }).toPromise();
  }

  getLeaveCodes(id: number) {
    return this.http.get("/Time-Off/GetLeaveCodes?id=" + id).toPromise();
  }

  insertCashOutRequest(pREHKeyID: number, pREndDate: string, cashHours: number) {
    return this.http.post("/Time-Off/InsertCashOutRequest",
      {
        id: pREHKeyID,
        date: pREndDate,
        hours: cashHours
      }).toPromise();
  }

  getLeaveReason() {
    return this.http.get("/Time-Off/GetLeaveReason").toPromise();
  }

  getApproverByPREHKeyID(pREHKeyID: number) {
    return this.http.get("/Time-Off/GetApproverByPREHKeyID?id=" + pREHKeyID).toPromise();
  }

  timeoffAutoVP(fileName: string, fileData: any, moduleID: number, recordKeyIDList: any[], fileAttachmentID: any, fileAttachmentType: string) {
    return this.http.post("/Document/timeoffAutoVP",
      {
        fileName: fileName,
        fileData: fileData,
        moduleID: moduleID,
        recordKeyIDList: recordKeyIDList,
        fileAttachmentID: fileAttachmentID,
        fileAttachmentType: fileAttachmentType
      }).toPromise();
  }

  insertLeaveRequest(id: number, dateStrings: any[], submittedNotes: string, leaveCodeId: string, hours: any, totalHours: number, reqType: string, format: string, reasonCode: string) {
    return this.http.post("/Time-Off/InsertLeaveRequest",
      {
        id: id,
        dateStrings: dateStrings,
        submittedNotes: submittedNotes,
        leaveCodeId: leaveCodeId,
        hours: hours,
        totalHours: totalHours,
        reqType: reqType,
        format: format,
        reasonCode: reasonCode
      }).toPromise();
  }

  getRequestsByMonth(pRCo?: number, monthStr?: string, employee?: number) {
    return this.http.get("/Admin/GetRequestsByMonth?pRCo=" + pRCo + "&monthStr=" + monthStr + "&employee=" + employee).toPromise();
  }

  getHolidaysByUserKeyID(id: number, year: any) {
    return this.http.get("/Time-Off/GetHolidaysByUserKeyID?id=" + id + "&year=" + year).toPromise();
  }

  downloadICSMulti(icsList: any) {
    return this.http.post("/Time-Off/DownloadICSMulti", {
      icsList: icsList
    }).toPromise();
  }

  async getLeaveCodeDesc(params: HttpParams): Promise<LeaveCode[]> {
    return this.http.get<Promise<LeaveCode[]>>("/Time-Off/GetLeaveCodeDesc", { params: params }).toPromise();
  }
}

export interface LeaveCode {
  PRCo: number | null;
  LeaveCode: string;
  LeaveCodeDesc: string;
};